
import { mapGetters, mapMutations, mapActions } from 'vuex'
import LoleSize from '~/components/size/lole-size'
export default {
  components: {
    LoleSize,
  },
  props: {
    facetData: {
      type: Object,
      default: () => ({}),
    },
    filterData: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    selectedSize: '',
    isFocused: false,
  }),
  computed: {
    ...mapGetters({
      vxSearchFilters: 'search/getSearchFilters',
    }),
    filterValue() {
      return `filter.${this.facetData.field}=${this.filterData.value}`
    },
    searchFilters: {
      get() {
        return this.vxSearchFilters
      },
      set(value) {
        this.vxSetSearchFilters(value)
        this.vxQuerySearchspring()
      },
    },
    isSelected() {
      return this.vxSearchFilters.includes(this.filterValue)
    },
  },
  methods: {
    ...mapActions({
      vxQuerySearchspring: 'search/querySearchspring',
    }),
    ...mapMutations({
      vxSetSearchFilters: 'search/setSearchFilters',
    }),
  },
}
